import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle, FaInfoCircle } from 'react-icons/fa';
import './NotificationToast.css';

const NotificationToast = ({ message, type = 'success' }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="toast-icon" />;
      case 'error':
        return <FaTimesCircle className="toast-icon" />;
      case 'warning':
        return <FaExclamationTriangle className="toast-icon" />;
      case 'info':
        return <FaInfoCircle className="toast-icon" />;
      default:
        return <FaCheckCircle className="toast-icon" />;
    }
  };

  return (
    <div className={`notification-toast notification-${type}`}>
      {getIcon()}
      <span className="toast-message">{message}</span>
    </div>
  );
};

export default NotificationToast;
